<div class="flex items-center justify-center">

    <div class="routed-content justify-center items-center flex flex-col w-full" #routedContainer>
        <div class="flex gap-2 items-center w-100">
            <a [routerLink]="['/leagues']" class="back-button flex items-center justify-center gap-2 no-decoration">
                <i class="material-icons">arrow_back</i>
                <span>Back</span>
            </a>
            <h2 class="w-70 center-text">Create New League</h2>
        </div>
        <app-league-form [league]="null" [parentLoading]="loading" (updateLeague)="createLeague($event)"></app-league-form>
    </div>
</div>

<ng-template #loadingMsg>
    <p>One moment...</p>
</ng-template>